export const PUT_MARK_NOTIFICATION_AS_READ = 'PUT_MARK_NOTIFICATION_AS_READ';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_SCROLL_NOTIFICATIONS = 'GET_SCROLL_NOTIFICATIONS';
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
export const SET_PULLED = 'SET_PULLED';
